document.addEventListener(
  'deviceready',
  () => {
    /*
     * iOS 12 app stuck on splashscreen
     * https://github.com/apache/cordova-plugin-splashscreen/issues/157#issuecomment-428280197
     */
    if (device && device.platform.toLowerCase() === 'ios') {
      setTimeout(() => {
        if (navigator) {
          navigator.splashscreen.hide()
        }
      }, 1000)
    }

    const container = require('./container').default
    container.resolve('app')
  },
  false
)
